import ReactDjangosoft from '../assets/img/portfolio/react/djangosoft.png';
import ReactOutsite from '../assets/img/portfolio/react/outsite.png';
import VuePropify from '../assets/img/portfolio/vue/propify.png';
import VueShipbob from '../assets/img/portfolio/vue/shipbob.png';
import AngularEzond from '../assets/img/portfolio/angular/ezond.png';
import AngularSelltime from '../assets/img/portfolio/angular/selltime.png';
import LaravelCar from '../assets/img/portfolio/laravel/favoridecarrental.png';
import WordprssJNJ from '../assets/img/portfolio/wordpress/cakaliko.kinsta.cloud.png';
import WordprssEdu from '../assets/img/portfolio/wordpress/isuniversity.org.png';
import WordprssBeauty from '../assets/img/portfolio/wordpress/lowellacademy.com.png';
import WordpressFootball from '../assets/img/portfolio/wordpress/melroseyouthfootball.com.png';
import CmsSmoWorks from '../assets/img/portfolio/cms/smoworks.png';
import CmsTrihydro from '../assets/img/portfolio/cms/trihydro.png';

const initialState = {
  list: [
    {id: 1, img: ReactDjangosoft, title: `React Djangosoft`, description: `Company Landing Page, Portfolio`, types: ['react', 'node']},
    {id: 2, img: ReactOutsite, title: `React Outsite`, description: `Real estate Platform`, types: ['react', 'node']},
    {id: 3, img: VuePropify, title: `Vue Propify`, description: `Real estate Management`, types: ['vue', 'laravel']},
    {id: 4, img: VueShipbob, title: `Vue Shipbob`, description: `Logistics Platform`, types: ['vue', 'wordpress']},
    {id: 5, img: AngularEzond, title: `Angular Ezond`, description: `Google Ads Tracking`, types: ['angular', 'node', 'laravel' ]},
    {id: 6, img: AngularSelltime, title: `Angular Selltime`, description: `Project Management Tool`, types: ['angular', 'node']},
    {id: 7, img: LaravelCar, title: `Laravel Favoride`, description: `Car Industry`, types: ['laravel']},
    {id: 8, img: WordprssJNJ, title: `Wordpress JNJ`, description: `Electronics, Industrial & Manufacturing`, types: ['wordpress']},
    {id: 9, img: WordprssEdu, title: `Wordpress University`, description: `University Site`, types: ['wordpress']},
    {id: 10, img: WordprssBeauty, title: `Wordpress Beauty`, description: `Beauty Site`, types: ['wordpress']},
    {id: 11, img: WordpressFootball, title: `Wordpress Football`, description: `Football Site`, types: ['wordpress']},
    {id: 12, img: CmsSmoWorks, title: `CMS Hubspot`, description: `Hubspot Website`, types: ['cms']},
    {id: 13, img: CmsTrihydro, title: `CMS Sitefinity`, description: `Sitefinity Website`, types: ['cms']},
  ]
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
